import React, { useState } from "react";
import { MobileMenu } from "features/shell";

type Order = {
  title: string;
  date: string;
  status: string;
  type: string;
  price: string;
  transaction_id: string;
};

const MobileOrderHistoryPage: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const orders: Order[] = [
    {
      title: "Metatopia in 3D",
      date: "Sep 22, 2025",
      status: "active",
      type: "Buy",
      price: "€11.99",
      transaction_id: "ch_1NtrTV2eZvKYlo2CjT2WUvqT",
    },
    {
      title: "Western Front: A soldier's point of view",
      date: "Mar 15, 2025",
      status: "expired",
      type: "Rent",
      price: "€3.99",
      transaction_id: "ch_1NtrTV2eZvKYlo2CjT2WUvqT",
    },
    {
      title: "Children of the void",
      date: "May 13, 2025",
      status: "active",
      type: "Rent",
      price: "€3.99",
      transaction_id: "ch_1NtrTV2eZvKYlo2CjT2WUvqT",
    },
    {
      title: "Children of the void",
      date: "Mar 13, 2025",
      status: "expired",
      type: "Rent",
      price: "€3.99",
      transaction_id: "ch_1NtrTV2eZvKYlo2CjT2WUvqT",
    },
    {
      title: "Children of the void",
      date: "Mar 13, 2025",
      status: "expired",
      type: "Rent",
      price: "€3.99",
      transaction_id: "ch_1NtrTV2eZvKYlo2CjT2WUvqT",
    },
    {
      title: "Children of the void",
      date: "Mar 13, 2025",
      status: "expired",
      type: "Rent",
      price: "€3.99",
      transaction_id: "ch_1NtrTV2eZvKYlo2CjT2WUvqT",
    },
    {
      title: "Children of the void",
      date: "Mar 13, 2025",
      status: "expired",
      type: "Rent",
      price: "€3.99",
      transaction_id: "ch_1NtrTV2eZvKYlo2CjT2WUvqT",
    },
    {
      title: "Children of the void",
      date: "Mar 13, 2025",
      status: "expired",
      type: "Rent",
      price: "€3.99",
      transaction_id: "ch_1NtrTV2eZvKYlo2CjT2WUvqT",
    },
  ];

  return (
    <div className="menu-component-mobile">
      <div className="main-container-home-mobile">
        <div className="menu-component-header-mobile">
          <img
            src="/images/poetics-stream-lockup.svg"
            alt="Poetics Stream"
            className="quima-logo-mobile"
          />
          <img
            src="/images/mobile/hamburger-menu.svg"
            alt="menu"
            className="quima-menu-btn-mobile"
            onClick={toggleMenu}
          />
        </div>
        <div className="menu-component-mid-container-mobile">
          <div className="menu-component-mid-title-container-mobile">
            <div className="menu-component-title-mobile">Order history</div>
            <div className="menu-component-subtitle-mobile">
              View your orders
            </div>
          </div>
          <div className="orders-container-mobile">
            {orders.map((order, idx) => (
              <div className={`order-card-mobile ${order.status}`} key={idx}>
                <div className="order-card-header-mobile">
                  <span className={`order-status-label-mobile ${order.status}`}>
                    {order.status === "active" ? "Active" : "Expired"}
                  </span>
                  <span className="order-date-mobile">
                    {order.date.replace(/-/g, " ")}
                  </span>
                </div>
                <div className="order-title-mobile">{order.title}</div>
                <div className="order-type-price-mobile">
                  {order.type === "Buy"
                    ? `Bought - ${order.price}`
                    : `Rented (30 days) - ${order.price}`}
                </div>
                <div className="order-transaction-mobile">
                  {order.transaction_id}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      )}
    </div>
  );
};

export default MobileOrderHistoryPage;
